import { Reveal } from "@/components/shared/Reveal";
import { ArrowRight, Star, Users } from "lucide-react";
import { openPreRegister } from "@/lib/preRegisterModal";
import { useFoundingDriverCount } from "@/hooks/useFoundingDriverCount";

export const FoundingDriverProgram = () => {
  const foundingDriverCount = useFoundingDriverCount();

  return (
    <section id="founding-drivers" data-testid="founding-driver-section" className="py-24 md:py-32 bg-rr-navy relative overflow-hidden">
      <div className="grain-overlay" />
      <div className="max-w-3xl mx-auto px-5 md:px-8 text-center relative">
        <Reveal>
          <div className="inline-flex items-center gap-2 text-rr-orangeLight text-xs font-bold tracking-[0.2em] uppercase mb-5">
            <Star size={14} /> Founding Driver Program
          </div>
          <h2 data-testid="founding-driver-heading" className="font-heading text-3xl md:text-5xl font-extrabold text-white leading-tight tracking-tight">
            Become a Founding RelayRigs Driver
          </h2>
          <p className="mt-5 text-white/70 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            Join the network before launch and be among the first drivers notified as RelayRigs opportunities become available.
          </p>

          {foundingDriverCount !== null && foundingDriverCount > 0 && (
            <div
              data-testid="founding-driver-counter"
              className="mt-8 inline-flex items-center gap-3 bg-white/10 border border-white/20 rounded-full px-6 py-3"
            >
              <Users size={18} className="text-rr-orangeLight" />
              <span className="font-heading text-2xl font-extrabold text-white">{foundingDriverCount.toLocaleString()}</span>
              <span className="text-white/70 text-sm font-semibold">founding drivers already on the list</span>
            </div>
          )}

          <button
            onClick={() => openPreRegister("driver")}
            data-testid="founding-driver-cta"
            className="mt-9 inline-flex items-center gap-2 bg-rr-orange text-white font-bold px-8 py-4 rounded-full hover:bg-white hover:text-rr-navy transition-all hover:-translate-y-1 shadow-xl shadow-black/20"
          >
            Join the Founding Driver Network <ArrowRight size={18} />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
